import { useLocation } from 'react-router-dom';
import { adminToken, token, wholeSaleToken } from '../config/token';
import {
  adminComponents,
  publicComponents,
  wholesaleComponents,
} from '../config/antdComponents';
import { WHOLESALE_PREFIX } from 'enums/publicRoutes';
import { ADMIN_BASE } from 'enums/adminRoutes';

export const useThemeConfig = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith(ADMIN_BASE);

  const pathname = window.location.pathname;
  const isWholeSale = pathname.includes(WHOLESALE_PREFIX);
  const isAdmin = pathname.includes(ADMIN_BASE);

  let innerToken: any = token;
  let innerComponent: any = publicComponents;

  if (isWholeSale) {
    innerToken = wholeSaleToken;
    innerComponent = wholesaleComponents;
  }

  if (isAdmin) {
    innerToken = adminToken;
    innerComponent = adminComponents;
  }

  return {
    isAdminRoute,
    antdTheme: {
      token: innerToken,
      components: innerComponent,
    },
    styledTheme: innerToken,
  };
};
